import { useRef } from "react";
import { QRCodeCanvas } from "qrcode.react";
import { Layout } from "@/components/Layout";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Download, ExternalLink, QrCode } from "lucide-react";

const CARD_URL = "https://mohamotors.com/carte";

export default function BusinessCardQRPage() {
  const wrap = useRef(null);

  const download = () => {
    const canvas = wrap.current.querySelector("canvas");
    const a = document.createElement("a");
    a.href = canvas.toDataURL("image/png");
    a.download = "QR_carte_MOHA_MOTORS.png";
    a.click();
  };

  return (
    <Layout>
      <Card className="max-w-md" data-testid="card-qr-page">
        <CardHeader>
          <CardTitle className="flex items-center gap-2"><QrCode className="w-5 h-5" />QR carte de vizită</CardTitle>
          <p className="text-sm text-muted-foreground">Scanează pentru a deschide cartea de vizită digitală Mohamed Jedda · MOHA MOTORS.</p>
        </CardHeader>
        <CardContent className="space-y-4">
          <div ref={wrap} className="bg-white p-5 rounded-xl inline-block" data-testid="card-qr-code">
            <QRCodeCanvas value={CARD_URL} size={256} level="H" marginSize={2} />
          </div>
          <p className="font-mono text-sm" data-testid="card-qr-url">{CARD_URL}</p>
          <div className="flex flex-wrap gap-2">
            <Button onClick={download} data-testid="card-qr-download"><Download className="w-4 h-4 mr-2" />Descarcă PNG</Button>
            <Button variant="outline" asChild>
              <a href="/carte" target="_blank" rel="noopener noreferrer" data-testid="card-qr-open"><ExternalLink className="w-4 h-4 mr-2" />Deschide cartea</a>
            </Button>
          </div>
        </CardContent>
      </Card>
    </Layout>
  );
}
